/* istanbul ignore file */
import { css } from '@linaria/core';
import { lighten } from 'polished';
import { baseTheme } from 'styles/utils';
export interface RingProps {
  /**
   * The size, in pixels, of the ring's inner area.
   */
  ringSize?: number;

  /**
   * The width, in pixels, of the ring itself.
   */
  ringWeight?: number;
}
export function IconRing(props: React.PropsWithChildren<RingProps>): JSX.Element | null {
  const {
    ringSize = 64,
    ringWeight = 12
  } = props;
  const outerStyles = {
    borderWidth: `${ringWeight}px`,
    borderStyle: 'solid',
    width: `${ringSize}px`,
    height: `${ringSize}px`
  };
  return <div className={DoubleCircleCls} style={outerStyles}>
      <div className="ring-inner">{props.children}</div>
    </div>;
}
const DoubleCircleCls = "omponents__IconRing__IconRing_tsx-DoubleCircleCls-d1k7o9rj";

require("./IconRing.linaria.module.css!=!../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./IconRing.tsx");